module.exports = __webpack_public_path__ + "img/79ne.c086a6cf.svg";